import React,{useState, useEffect} from 'react'
import Arrow from '../../assets/images/arrow.svg'
import { useHistory } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import Logo from '../../assets/images/EZ_LEISURE_LOGO.svg';
import { PasswordValidation} from '../../utils/Validation.js'
import { useDispatch } from 'react-redux';
import { Put} from '../../Api/ApiMethods.js';
import { 
    resetPasswordEmailUrl
 } from '../../Routes/ApiRoutes';

export default function ResetPassword(props) {
    const dispatch = useDispatch();
    const history = useHistory()
    if(!props.location.state)
    {
        history.push(`/login`)
    }
    const [seconds, setSeconds] = useState(3 * 60);
    const [timer, setTimer] = useState('');

    const [isExpired, setIsExpired] = useState(false);
    useEffect(() => {
        if (seconds > 0) {
          let min = Math.floor(seconds/60);
          let sec = seconds - min * 60;
          setTimer((min.toString().length > 1 ? min : '0'+ min)  + ':' + (sec.toString().length > 1 ? sec : '0'+ sec));
          setTimeout(() => setSeconds(seconds - 1), 1000);
        } else {
          setSeconds('OTP Expired!');
          setIsExpired(true)
        }
      });
    const data = props.location.state;
    const [obj ,setObj] = useState({
        "email": data && data.email.email,
        "otp": 0,
        "password": '',
        "confirm_password": "",
      });

    const [otpError, setOtpError] = useState(null);
    const [passError, setPassError] = useState(null);
    const [confrmPassError, setConfrmPassError] = useState(null);

    const handleSubmit = () => {
        if(! isExpired){
            if(obj.otp === 0)
            {
                setOtpError('OTP cannot be blank.')
            }
            if(obj.password === '')
            {
                setPassError('Password cannot be blank.')
            }
            if(obj.confirm_password === '')
            {
                setConfrmPassError('Confirm password cannot be blank.')
            }
            if(obj.confirm_password !== '' && obj.Password !== '' && obj.otp !== '' && !(otpError) && !(passError) &!(confrmPassError))
            {
            try {
                Put(resetPasswordEmailUrl, obj)
                .then(response => {
                    if(response.status === 200)
                    {
                        toast.success("Password changed. Please login again.")
                        dispatch({
                            type: 'SIGN_OUT',
                            payload: null,
                        });
                        setTimeout(() => history.push(`/login`), 2100)
                    }
                })
                .catch(error => {
                  toast.error(error.error)
                })
              }catch (error) {
                console.log(error);
              }
            }
        }
        else{
            toast.success("OTP expired. Please try again.")
        }
    }

    var handleOtpInput = (e) => {
        let updatedDetails = { ...obj };
        updatedDetails[e.target.id] = e.target.id === "otp" ? parseInt(e.target.value) : e.target.value;
        setObj(updatedDetails)

        setOtpError(null);
    }

    var handleConfrmPassInput = (e) => {
        if(obj.password == e.target.value)
        { 
            let updatedDetails = { ...obj };
            updatedDetails[e.target.id] = e.target.value;
            setObj(updatedDetails)
        
            setConfrmPassError(null);
        }
        else{
            setConfrmPassError('It does not match with password');
        }
    }
    
    var handlePassInput = (e) => {
        if(PasswordValidation(e.target.value))
        {
            let updatedDetails = { ...obj };
            updatedDetails[e.target.id] = e.target.value;
            setObj(updatedDetails)
            
            setPassError(null);
        }
        else{
            setPassError('Must have at least one uppercase letter, one lowercase letter, one number and one of the special characters #?!@$%^&*-.');
        }
    }
    
    return (<>
        <section class="sign-in-wrapper Forgot-Wpassword">
            <div class="container">
                <div class="sign-in">
                <h3> <img onClick={() => history.push(`/profile`)} src={Arrow} />
                    <span>Setup new password</span>
                </h3>
                { data && <p>OTP has been sent to {data.email.email}. }</p>}
                    <div class="form-group">
                        <input style={{borderColor : otpError ? 'red' : '#fff'}} onChange={(e) => handleOtpInput(e)} 
                        autoComplete='off' id='otp' type="password" class="form-control" placeholder="OTP" />
                        {otpError && <span className='form-error'>{otpError}</span>}
                    </div>
                    <div className="form-group">
                      <input style={{borderColor : passError ? 'red' : '#fff'}} onChange={(e) => handlePassInput(e)}
                       autoComplete='off' type="password" id='password' className="form-control" placeholder="Password" />
                       {passError && <span className='form-error'>{passError}</span>}
                    </div>
                    <div className="form-group">
                      <input style={{borderColor : confrmPassError ? 'red' : '#fff'}} onChange={(e) => handleConfrmPassInput(e)}
                       autoComplete='off' type="password" id='confirm_password' className="form-control" placeholder="Confirm Password" />
                       {confrmPassError && <span className='form-error'>{confrmPassError}</span>}
                    </div>
                    <div class="re-send">
                        <p class="resend-btn">
                        {isNaN(seconds) && <a className='link'>Resend</a>}
                        </p>
                        <p class="time"> {isNaN(seconds) ? seconds : timer }</p>
                    </div>
                    <ToastContainer position="top-center" autoClose={2000}/>
                    <div class="comman-btn">
                        <button onClick={() => handleSubmit()}>Submit</button>
                    </div> 
                </div>
            </div>
        </section>
    </>)
}
